<mat-card *ngIf="course() as course; else loading">
  <mat-card-header>
    <mat-card-title>{{course.title | capitalize}}</mat-card-title>
    <a mat-button [routerLink]="['/courses/' + course.id + '/edit']" color="primary">
      Edit
    </a>
  </mat-card-header>

  <mat-card-content>
      <mat-card-subtitle>Details</mat-card-subtitle>
      <p>{{course.description}}</p>
      <!--<mat-card-subtitle>Subject</mat-card-subtitle>-->
      <!--<p>{{course.subject}}</p>-->
    <br>
    <mat-card>
      <mat-card-title>
        Lessons
        <a mat-button [routerLink]="['/courses/' + course.id + '/lessons/create/']" color="primary">
          Add Lesson
        </a>
      </mat-card-title>

      <mat-card-content>
        <mat-accordion>
          <!--Lesson Start -->

          <mat-expansion-panel *ngFor="let lesson of course.lessons" [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>{{lesson.title}}</mat-panel-title>
              <button mat-button color="primary"
                      [routerLink]="['/courses/' + course.id + '/lessons/' + lesson.id + '/manage']">
                Manage
              </button>
              <button mat-button color="primary" [routerLink]="['/courses/' + course.id + '/lessons/' + lesson.id + '/edit']">
                Edit
              </button>
            </mat-expansion-panel-header>

            <mat-list>
              <mat-list-item>
                <mat-card-subtitle>{{lesson.pacingGoal}}</mat-card-subtitle>
                <p mat-line class="secondary-text">Pacing Goal (Total Minutes)</p>
              </mat-list-item>
              <mat-list-item>
                <mat-card-subtitle>{{lesson.accuracyGoal}}</mat-card-subtitle>
                <p mat-line class="secondary-text">Accuracy Goal (Percent Correct)</p>
              </mat-list-item>
            </mat-list>

            <p>{{lesson.description}}</p>

            <!-- Exercises Start-->
            <mat-accordion>
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>Exercises</mat-panel-title>
                </mat-expansion-panel-header>

                <mat-list>
                  <mat-list-item *ngFor="let exercise of lesson.exercises">
                    <mat-panel-title>{{exercise.title}}</mat-panel-title>
                    <button mat-button color="primary"
                            [routerLink]="['/courses/' + course.id + '/lessons/' + lesson.id + '/exercises/' + exercise.id + '/manage']">
                      Manage
                    </button>
                  </mat-list-item>
                </mat-list>
                <mat-action-row>
                  <button mat-raised-button color="primary"
                          routerLink='/courses/{{course.id}}/lessons/{{lesson.id}}/exercises/create'>
                    Add Exercise
                  </button>
                </mat-action-row>
              </mat-expansion-panel>
            </mat-accordion>

          </mat-expansion-panel>
          <!--Exercises End-->
          <!--Lesson End -->
        </mat-accordion>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>

<ng-template #loading>
  <app-spinner></app-spinner>
</ng-template>
